module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Prologue"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("INTO ACTION")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter_1#au1"
    }
  }, [_vm._v("RICHARD PIKE")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("SURPRISE")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_2#au2"
    }
  }, [_vm._v("ARCHIE LIGGAT")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_3"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("NAVAL HAZARDS")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_3#au3"
    }
  }, [_vm._v("ALAN WINKLES")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("FIGHTER CONTROLLER")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_4#au4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PENNY SMITH")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("STARS AND STRIPES")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_5#au5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCOTT SONNENBERG")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("OPEN SESAME")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_6#au6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JACK HAMILL AND PETER DESMOND")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("FALKLANDS PHANTOMS")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_7#au7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN WALMSLEY")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("PERSEVERANCE")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_8#au8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RICHARD PIKE")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("HYDRAULIC HASSLE")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_9#au9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALAN WINKLES")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("MAKING WAVES")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_10#au10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RONALD ‘ROLY’ TOMLIN")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 11")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("CLOSE ENCOUNTERS")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_11#au11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DICK NORTHCOTE")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 12")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("PROXY PILOT")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_12#au12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALAN WINKLES")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 13")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("MIXED MESSAGES")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_13#au13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN MEGARRY")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 14")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("ITALIAN JOB")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_14#au14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ARCHIE LIGGAT")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 15")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("FOUR-SECOND SOLO")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_15#au15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JON ‘HERBIE’ HANCOCK")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 16")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("GOLDEN SILENCE")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_16#au16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHIL OWEN")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 17")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("YANKEE PHANTOM FLYER ON THREE CONTINENTS")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_17#au17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RG HEAD")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("CHAPTER 18")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("PHANTOM FAREWELL")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "tochangA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_18#au18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RICHARD PIKE")])]), _vm._v(" "), _c('h2', {
    staticClass: "tochang1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tcolor"
  }, [_c('span', {
    staticClass: "t_hang"
  }, [_vm._v("APPENDIX")]), _vm._v(" "), _c('span', {
    staticClass: "t1color"
  }, [_vm._v("SELECT BIOGRAPHIES")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8ca3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0